import {useRouter} from 'next/router';

import {LegalPage} from '@components/legal/LegalPage';
import {PageLayout} from '@components/common/PageLayout';
import {withCommonTranslations} from '@modules/i18n/withCommonTranslations';
import {getLegalLocale, TERMS_OF_USE} from '@modules/legal/content';
import {SeoHead} from '@modules/seo/SeoHead';

const CguPage = () => {
	const router = useRouter();
	const legalLocale = getLegalLocale(router.locale ?? router.defaultLocale);
	const document = TERMS_OF_USE[legalLocale];

	return (
		<>
			<SeoHead title={document.title} description={document.description} />
			<PageLayout testId="CguPage-layout">
				<LegalPage
					testId="CguPage"
					title={document.title}
					sections={document.sections}
				/>
			</PageLayout>
		</>
	);
};

export const getStaticProps = withCommonTranslations();

export default CguPage;
